import useWarehouseInvoiceSetting from "./useWarehouseInvoiceSetting";
import { normalizeInvoiceQrFlag } from "../utils/invoiceQrVisibility";
import { isInvoiceSubjectEnabled } from "../utils/invoiceSubject";

export default function useWarehouseInvoiceQrSetting(options) {
  return useWarehouseInvoiceSetting({ ...options, field: "show_qr_code_on_invoice", normalize: normalizeInvoiceQrFlag, label: "QR" });
}

export function useWarehouseInvoiceSubjectSetting(options) {
  return useWarehouseInvoiceSetting({ ...options, field: "invoice_subject_enabled", normalize: isInvoiceSubjectEnabled, label: "objet" });
}
